export default "__VITE_ASSET__c690ac0d__"